"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _OrgCreditBanner = _interopRequireDefault(require("./OrgCreditBanner")),
    _TeamCredits = _interopRequireDefault(require("./TeamCredits")),
    CreditInfo = function CreditInfo(a) {
  var b = a.teamCreditInfo,
      c = a.orgCreditInfo,
      d = a.onSelectTeam,
      e = c["package"];
  e = void 0 === e ? {} : e;
  var f = e.creditType;
  return _react["default"].createElement(_react["default"].Fragment, null, (0 === b.length || "SHARE" === f) && _react["default"].createElement(_OrgCreditBanner["default"], {
    orgCreditInfo: c
  }), 0 < b.length && _react["default"].createElement(_TeamCredits["default"], {
    teamCreditInfo: b,
    creditType: f,
    onSelectTeam: d
  }), _react["default"].createElement("hr", {
    className: "payment-options__body__horizontal-line"
  }));
},
    _default = CreditInfo;

exports["default"] = _default;